import * as React from 'react';

import { MetricBaseCard } from './MetricBaseCard';
import { MetricCardProps } from './MetricCardProps';

export const StandardMetricCard = (props: MetricCardProps): JSX.Element => <MetricBaseCard {...props} />;
